"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _objectDestructuringEmpty2 = require("babel-runtime/helpers/objectDestructuringEmpty");

var _objectDestructuringEmpty3 = _interopRequireDefault(_objectDestructuringEmpty2);

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

require("./index.css");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var PrivacyPolicy = function PrivacyPolicy(_ref) {
  (0, _objectDestructuringEmpty3.default)(_ref);

  return _react2.default.createElement(
    "div",
    { className: "privacy-container" },
    _react2.default.createElement(
      "h3",
      { className: "privacy-main-header" },
      "Privacy Policy for mSeva"
    ),
    _react2.default.createElement(
      "p",
      null,
      "Welcome to mSeva. mSeva app developed by eGovernments Foundation and launched in collaboration with Department of Local Government Punjab, is an advanced citizen application enabling citizens to report a civic related issue."
    ),
    _react2.default.createElement(
      "p",
      null,
      "Our Privacy Policy explains how we and the Companies/Government offices we work with collect, use, share and protect information in relation to our mobile services, web site, and any software provided on or in connection with mSeva, and your choices about the collection and use of your information."
    ),
    _react2.default.createElement(
      "p",
      null,
      "By using our Service you understand and agree that we are providing a platform for you to post content, including photos, comments and other materials (\"User Content\"), to the Service and to share User Content publicly. This means that other Users may search for, see, use, or share any of your User Content that you make publicly available through the Service."
    ),
    _react2.default.createElement(
      "p",
      null,
      "Our Policy applies to all visitors, users, and others who access the Service (\"Users\")."
    ),
    _react2.default.createElement(
      "h3",
      { className: "privacy-sub-header" },
      "1. INFORMATION WE COLLECT"
    ),
    _react2.default.createElement(
      "p",
      null,
      "We collect the following types of information."
    ),
    _react2.default.createElement(
      "p",
      null,
      "Your names, phone numbers, city and OTP sent via SMS when you register on mSeva app."
    ),
    _react2.default.createElement(
      "p",
      null,
      "Profile information that you provide for your user profile (e.g., first and last name, picture, etc. This information allows us to help you or others be \"found\" on mSeva through user content (e.g., photos, comments, and other materials) that you post to the Service. For example, we may send you Service-related emails (e.g., account verification, changes/updates to features of the Service, technical and security notices). Note that you may not opt out of Service-related e-mails."
    ),
    _react2.default.createElement(
      "h3",
      { className: "privacy-bold" },
      "Analytics information:"
    ),
    _react2.default.createElement(
      "p",
      null,
      "We use third-party analytics tools to help us measure traffic and usage trends for the Service. These tools collect information sent by your device or our Service, including the web pages you visit, add-ons, and other information that assists us in improving the Service. We collect and use this analytics information with analytics information from other Users so that it cannot reasonably be used to identify any particular individual User."
    ),
    _react2.default.createElement(
      "h3",
      { className: "privacy-bold" },
      "Cookies and similar technologies:"
    ),
    _react2.default.createElement(
      "p",
      null,
      "When you visit the Service, we may use cookies and similar technologies like pixels, web beacons, and local storage to collect information about how you use mSeva and provide features to you. We may ask advertisers or other partners to serve ads or services to your devices, which may use cookies or similar technologies placed by us or the third party."
    ),
    _react2.default.createElement(
      "h3",
      { className: "privacy-bold" },
      "Log file information:"
    ),
    _react2.default.createElement(
      "p",
      null,
      "Log file information is automatically reported by your browser each time you make a request to access (i.e., visit) a web page or app. It can also be provided when the content of the webpage or app is downloaded to your browser or device."
    ),
    _react2.default.createElement(
      "p",
      null,
      "When you use our Service, our servers automatically record certain log file information, including your web request, Internet Protocol (\"IP\") address, browser type, referring / exit pages and URLs, number of clicks and how you interact with links on the Service, domain names, landing pages, pages viewed, and other such information. We may also collect similar information from emails sent to our Users which then help us track which emails are opened and which links are clicked by recipients. The information allows for more accurate reporting and improvement of the Service."
    ),
    _react2.default.createElement(
      "h3",
      { className: "privacy-bold" },
      "Device Identifiers:"
    ),
    _react2.default.createElement(
      "p",
      null,
      "When you use a mobile device like a tablet or phone to access our Service, we may access, collect, monitor, store on your device, and/or remotely store one or more \"device identifiers.\" Device identifiers are small data files or similar data structures stored on or associated with your mobile device, which uniquely identify your mobile device. A device identifier may be data stored in connection with the device hardware, data stored in connection with the device's operating system or other software, or data sent to the device by mSeva."
    ),
    _react2.default.createElement(
      "p",
      null,
      "A device identifier may deliver information to us or to a third party partner about how you browse and use the Service and may help us or others provide reports or personalized content and ads. Some features of the Service may not function properly if use or availability of device identifiers is impaired or disabled."
    ),
    _react2.default.createElement(
      "h3",
      { className: "privacy-bold" },
      "Metadata:"
    ),
    _react2.default.createElement(
      "p",
      null,
      "Metadata is usually technical data that is associated with User Content. For example, Metadata can describe how, when and by whom a piece of User Content was collected and how that content is formatted."
    ),
    _react2.default.createElement(
      "p",
      null,
      "Users can add or may have Metadata added to their User Content including a hashtag (e.g., to mark keywords when you post a photo), geotag (e.g., to mark your location to a photo), comments or other data. This makes your User Content more searchable by others and more interactive. If you geotag your photo or tag your photo using other's APIs then, your latitude and longitude will be stored with the photo and searchable (e.g., through a location or map feature) if your photo is made public by you in accordance with your privacy settings."
    ),
    _react2.default.createElement(
      "h3",
      { className: "privacy-sub-header" },
      "2. HOW WE USE YOUR INFORMATION"
    ),
    _react2.default.createElement(
      "p",
      null,
      "In addition to some of the specific uses of information we describe in this Privacy Policy, we may use information that we receive to:"
    ),
    _react2.default.createElement(
      "ul",
      { classname: "privacy-list" },
      _react2.default.createElement(
        "li",
        null,
        _react2.default.createElement(
          "p",
          null,
          "Help you efficiently access your information after you sign in."
        )
      ),
      _react2.default.createElement(
        "li",
        null,
        _react2.default.createElement(
          "p",
          null,
          " Remember information so you will not have to re-enter it during your visit or the next time you visit the Service"
        )
      ),
      _react2.default.createElement(
        "li",
        null,
        _react2.default.createElement(
          "p",
          null,
          "Provide personalized content and information to you and others, which could include online ads or other forms of marketing."
        )
      ),
      _react2.default.createElement(
        "li",
        null,
        _react2.default.createElement(
          "p",
          null,
          " Provide, improve, test, and monitor the effectiveness of our Service"
        )
      ),
      _react2.default.createElement(
        "li",
        null,
        _react2.default.createElement(
          "p",
          null,
          "Develop and test new products and features"
        )
      ),
      _react2.default.createElement(
        "li",
        null,
        _react2.default.createElement(
          "p",
          null,
          "Monitor metrics such as total number of visitors, traffic, and demographic patterns"
        )
      ),
      _react2.default.createElement(
        "li",
        null,
        _react2.default.createElement(
          "p",
          null,
          "Diagnose or fix technology problems"
        )
      ),
      _react2.default.createElement(
        "li",
        null,
        _react2.default.createElement(
          "p",
          null,
          "Automatically update the mSeva application on your device"
        )
      )
    ),
    _react2.default.createElement(
      "h3",
      { className: "privacy-sub-header" },
      "3. SHARING OF YOUR INFORMATION"
    ),
    _react2.default.createElement(
      "p",
      null,
      "We will not rent or sell your information to third parties outside mSeva (or the group of companies of which mSeva is a part) without your consent, except as noted in this Policy. Whenever you post a grievance on civic issues/violations on our apps, we pass on your details, and details of the problem, to the Urban Local Bodies as per the Memorandum of Understanding signed by eGovernments Foundation and the Urban Local Body."
    ),
    _react2.default.createElement(
      "p",
      null,
      "It is important we share these details as the Government Officers working with the Urban Local Body and responsible for the area where you located the problem will contact you with an intention to gain more details and hence work towards resolving the issue."
    ),
    _react2.default.createElement(
      "p",
      null,
      "Other than the officials who are assigned to resolve your grievance, only people we authorise to view the mSeva administration interface will be able to see your email address, phone number and they will never use it for anything other than to help administer."
    ),
    _react2.default.createElement(
      "p",
      null,
      "We will never give or sell your email address to anyone else, unless we are obliged to by law."
    ),
    _react2.default.createElement(
      "h3",
      { className: "privacy-bold" },
      "Parties with whom we may share your information:"
    ),
    _react2.default.createElement(
      "p",
      null,
      "We may share User Content and your information (including but not limited to, information from cookies, log files, device identifiers, location data, and usage data) with businesses that are legally part of the same group of companies that mSeva is part of, or that become part of that group (\"Affiliates\")."
    ),
    _react2.default.createElement(
      "p",
      null,
      "Affiliates may use this information to help provide, understand, and improve the Service (including by providing analytics) and Affiliates' own services (including by providing you with better and more relevant experiences). But these Affiliates will honor the choices you make about who can see your photos."
    ),
    _react2.default.createElement(
      "p",
      null,
      "We also may share your information as well as information from tools like cookies, log files, and device identifiers and location data, with third-party organizations that help us provide the Service to you (\"Service Providers\"). Our Service Providers will be given access to your information as is reasonably necessary to provide the Service under reasonable confidentiality terms."
    ),
    _react2.default.createElement(
      "p",
      null,
      "We may also share certain information such as cookie data with third-party advertising partners. This information would allow third-party ad networks to, among other things, deliver targeted advertisements that they believe will be of most interest to you."
    ),
    _react2.default.createElement(
      "p",
      null,
      "We may remove parts of data that can identify you and share anonymized data with other parties. We may also combine your information with other information in a way that it is no longer associated with you and share that aggregated information."
    ),
    _react2.default.createElement(
      "h3",
      { className: "privacy-bold" },
      "Parties with whom you may choose to share your User Content:"
    ),
    _react2.default.createElement(
      "p",
      null,
      "Any information or content that you voluntarily disclose for posting to the Service, such as User Content, becomes available to the public, as controlled by any applicable privacy settings that you set. To change your privacy settings on the Service, please change your profile setting. Once you have shared User Content or made it public, that User Content may be re-shared by others."
    ),
    _react2.default.createElement(
      "h3",
      { className: "privacy-bold" },
      "What happens in the event of a change of control:"
    ),
    _react2.default.createElement(
      "p",
      null,
      "If we sell or otherwise transfer part or the whole of mSeva or our assets to another organization (e.g., in the course of a transaction like a merger, acquisition, bankruptcy, dissolution, liquidation), your information such as name and email address, User Content and any other information collected through the Service may be among the items sold or transferred. You will continue to own your User Content. The buyer or transferee will have to honor the commitments we have made in this Privacy Policy."
    ),
    _react2.default.createElement(
      "h3",
      { className: "privacy-bold" },
      "Responding to legal requests and preventing harm:"
    ),
    _react2.default.createElement(
      "p",
      null,
      "We may access, preserve and share your information in response to a legal request (like a search warrant, court order or subpoena) if we have a good faith belief that the law requires us to do so. This may include responding to legal requests from jurisdictions outside of India where we have a good faith belief that the response is required by law in that jurisdiction, affects users in that jurisdiction, and is consistent with internationally recognized standards. We may also access, preserve and share information when we have a good faith belief it is necessary to: detect, prevent and address fraud and other illegal activity; to protect ourselves, you and others; including as part of investigations; and to prevent death or imminent bodily harm. Information we receive about you may be accessed, processed and retained for an extended period of time when it is the subject of a legal request or obligation, governmental investigation, or investigations concerning possible violations of our terms or policies, or otherwise to prevent harm."
    ),
    _react2.default.createElement(
      "h3",
      { className: "privacy-sub-header" },
      "4. HOW WE STORE YOUR INFORMATION"
    ),
    _react2.default.createElement(
      "h3",
      { className: "privacy-bold" },
      "Storage and Processing:"
    ),
    _react2.default.createElement(
      "p",
      null,
      "Your information collected through the Service may be stored and processed in India or any other country by third party services like Amazon in which mSeva, its Affiliates or Service Providers maintain facilities."
    ),
    _react2.default.createElement(
      "p",
      null,
      "We use commercially reasonable safeguards to help keep the information collected through the Service secure and take reasonable steps (such as requesting a unique password) to verify your identity before granting you access to your account. However, mSeva cannot ensure the security of any information you transmit to mSeva or guarantee that information on the Service may not be accessed, disclosed, altered, or destroyed."
    ),
    _react2.default.createElement(
      "p",
      null,
      "Please do your part to help us. You are responsible for maintaining the secrecy of your unique password and account information, and for controlling access to emails between you and mSeva, at all times. Your privacy settings may also be affected by changes the social media services you connect to mSeva make to their services. We are not responsible for the functionality, privacy, or security measures of any other organization."
    ),
    _react2.default.createElement(
      "h3",
      { className: "privacy-sub-header" },
      "5. YOUR CHOICES ABOUT YOUR INFORMATION"
    ),
    _react2.default.createElement(
      "h3",
      { className: "privacy-bold" },
      "Your account information and profile/privacy settings:"
    ),
    _react2.default.createElement(
      "p",
      null,
      "Update your account at any time by logging in and changing your profile settings. Unsubscribe from email communications from us by clicking on the \"unsubscribe link\" provided in such communications. As noted above, you may not opt out of Service-related communications (e.g., account verification, purchase and billing confirmations and reminders, changes/updates to features of the Service, technical and security notices)."
    ),
    _react2.default.createElement(
      "h3",
      { className: "privacy-bold" },
      "How long we keep your User Content:"
    ),
    _react2.default.createElement(
      "p",
      null,
      "Following termination or deactivation of your account, mSeva, its Affiliates, or its Service Providers may retain information (including your profile information) and User Content for a commercially reasonable time for backup, archival, and/or audit purposes."
    ),
    _react2.default.createElement(
      "h3",
      { className: "privacy-sub-header" },
      "6. OTHER WEB SITES AND SERVICES"
    ),
    _react2.default.createElement(
      "p",
      null,
      "We are not responsible for the practices employed by any websites or services linked to or from our Service, including the information or content contained within them. Please remember that when you use a link to go from our Service to another website or service, our Privacy Policy does not apply to those third-party websites or services. Your browsing and interaction on any third-party website or service, including those that have a link on our website, are subject to that third party's own rules and policies. In addition, you agree that we are not responsible and do not have control over any third-parties that you authorize to access your User Content. If you are using a third-party website or service and you allow them to access your User Content you do so at your own risk."
    ),
    _react2.default.createElement(
      "h3",
      { className: "privacy-sub-header" },
      "7. CHANGES TO OUR PRIVACY POLICY"
    ),
    _react2.default.createElement(
      "p",
      null,
      "mSeva may modify or update this Privacy Policy from time to time, so please review it periodically. We may provide you additional forms of notice of modifications or updates as appropriate under the circumstances. Your continued use of mSeva or the Service after any modification to this Privacy Policy will constitute your acceptance of such modification. If you have any questions about our privacy policy or wish to update any of the information you have provided us, please contact us at contact@egovernments.org"
    )
  );
};

exports.default = PrivacyPolicy;


//////////////////
// WEBPACK FOOTER
// ../lib/egov-ui-kit/common/common/PrivacyPolicy/index.js
// module id = ../lib/egov-ui-kit/common/common/PrivacyPolicy/index.js
// module chunks = 504